import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { InitialState } from './types'
import * as typesProfile from '../SignInPage/types'
import { useHistory } from 'react-router-dom'
import {
  checkProfileFilled,
  checkProfileRole,
  isDifferentAge,
} from '../../utils/helpers'
import ModalQuestionnaire from '../../components/ModalQuestionnaire'
import usePrevious from '../../hooks/usePrevious'

// Styles
import './styles.scss'

// Components
import Header from '../../components/Header'
import ProfileHeader from '../../components/ProfileHeader'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import ContestsDatabaseBlock from '../../components/ContestsDatabaseBlock'
import ModalInvite from '../../components/ModalInvite'

// Icons
import IconDownload from './images/iconDownload'
import ImageGreenLeaf from './images/imageGreenLeaf'

export default () => {
  const [modalQuestionnaire, setModalQuestionnaire] = useState<boolean>(false)
  const [modalInviteFriend, setModalInviteFriend] = useState<boolean>(false)
  const [isUpdateProfile, setIsUpdateProfile] = useState<boolean>(false)

  const dispatch = useDispatch()
  const history = useHistory()

  const isMounted = useRef<boolean>(false)

  const { contest, myWorks, works, isFetchingContests, isFetchingMyWorks } =
    useSelector(
      (state: { profileContests: InitialState }) => state.profileContests
    )

  const { profile, isProcessSave } = useSelector(
    (state: { profile: typesProfile.InitialState }) => state.profile
  )

  const prevIsProcessSave = usePrevious(isProcessSave)

  const isAdult =
    checkProfileRole(profile?.roles, 'parent') ||
    checkProfileRole(profile?.roles, 'teacher')

  const isAgeAdult =
    profile && profile.external_profile.birthdate
      ? isDifferentAge(profile.external_profile.birthdate, 18)
      : false

  const isBeingChecking =
    contest && !contest.results_calculated && contest.status === 'finished'

  const handleNavigateCreateWork = () => {
    if (contest) {
      history.push(`/profile/contests/${contest.contest_id}/works/create`)
    }
  }

  useEffect(() => {
    if (prevIsProcessSave && !isProcessSave) {
      setIsUpdateProfile(true)
    }
  }, [isProcessSave])

  useEffect(() => {
    if (isUpdateProfile && profile) {
      if (!isAgeAdult) {
        handleNavigateCreateWork()
      }
      setModalQuestionnaire(false)
      setIsUpdateProfile(false)
    }
  }, [profile])

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchContest())
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (contest && isMounted.current) {
      dispatch(actions.fetchMyWorks(contest.contest_id))
      dispatch(actions.fetchWorks(contest.contest_id))
    }
  }, [contest])

  useEffect(() => {
    if (isAdult) {
      history.replace('/contests-works')
    }
  }, [isAdult])

  const handleSendWork = () => {
    if (profile && checkProfileFilled(profile)) {
      handleNavigateCreateWork()
    } else {
      setModalQuestionnaire(true)
    }
  }

  return (
    <>
      <Header />
      <div className={'profile'}>
        <div className={'container'}>
          <ProfileHeader style={{ marginBottom: 48 }} />
          {isFetchingContests || isFetchingMyWorks || !isMounted.current ? (
            <LoadingPage />
          ) : contest ? (
            <>
              <div className={'profile__leaf'}>
                <ImageGreenLeaf />
              </div>
              <div className={'profile-contests'}>
                <div className={'profile-contests__header'}>
                  <h1 className={'title'}>Загруженные работы</h1>
                  {isBeingChecking ? (
                    <div className={'work-calculate'}>
                      Идет проверка работ. Результаты скоро появятся.
                    </div>
                  ) : null}
                </div>
                {myWorks && myWorks.length ? (
                  <div className={'my-works'}>
                    {myWorks.map(work => (
                      <div
                        key={work.user_contest_id}
                        className={'my-works__item'}
                      >
                        <div
                          className={
                            work.avg_score
                              ? 'my-works__item-button long score'
                              : 'my-works__item-button long'
                          }
                          onClick={() =>
                            history.push(
                              `/profile/contests/${contest.contest_id}/works/${work.user_contest_id}`
                            )
                          }
                        >
                          <span>{work.title}</span>
                          {work.avg_score ? (
                            <div className={'my-works__item-scores'}>
                              <div className={'value'}>{work.avg_score}</div>
                              <span className={'text'}>баллов</span>
                            </div>
                          ) : null}
                        </div>
                        <p className={'my-works__item-description'}>
                          {contest
                            ? contest.nominations.find(
                                item =>
                                  item.nomination_id === work.nomination_id
                              )?.caption
                            : null}
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={'no-work'}>
                    <div className={'no-work__description'}>
                      {isAgeAdult
                        ? 'К сожалению, вы не можете подать заявку.\nУчаствовать в данном конкурсе могут только дети от 12 до 18 лет.'
                        : 'Мы еще не видели твою работу.'}
                    </div>
                    {isAgeAdult ? null : (
                      <div className={'no-work__alert'}>Загружай скорее!</div>
                    )}
                  </div>
                )}
                <div className="line-hr" />
                <div className={'buttons'}>
                  {contest.status === 'started' ? (
                    <div className={'buttons__item'}>
                      <button disabled={isAgeAdult} onClick={handleSendWork}>
                        <IconDownload style={{ marginRight: 21 }} />
                        Загрузить работу
                      </button>
                    </div>
                  ) : null}
                  <div
                    onClick={() => setModalInviteFriend(true)}
                    className={'buttons__item'}
                  >
                    <button>Пригласить друга</button>
                  </div>
                </div>
                {works ? (
                  <>
                    <div className={'database__title'}>
                      БАЗА ДАННЫХ (ТОП РАБОТ)
                    </div>
                    <ContestsDatabaseBlock
                      works={works}
                      style={{ marginBottom: 48 }}
                    />
                    <button
                      onClick={() => history.push('/contests-works')}
                      className={'button-all'}
                    >
                      Посмотреть все работы
                    </button>
                  </>
                ) : null}
              </div>
            </>
          ) : (
            <h2 style={{ textAlign: 'center', cursor: 'default' }}>
              В настоящий момент не проводится ни одного конкурса
            </h2>
          )}
        </div>
      </div>
      <ModalQuestionnaire
        modal={modalQuestionnaire}
        onClose={() => setModalQuestionnaire(false)}
      />
      <ModalInvite
        modal={modalInviteFriend}
        typeInvite={'friend'}
        isReverse={false}
        alertDescription={'Поделитесь ей с другом!'}
        onClose={() => setModalInviteFriend(false)}
      />
      <Footer />
    </>
  )
}
